import { CardUnified } from './CardUnified';

/**
 * CardPostBig 컴포넌트 (하위 호환 래퍼)
 *
 * CardUnified 의 variant="postBig" 로 위임한다. 신규 코드는 CardUnified 를 직접 사용 권장.
 *
 * @param {Object} thread - 스레드 데이터 [Required]
 * @param {string} date - 표시할 날짜. 미지정 시 thread.timestamp 사용 [Optional]
 * @param {number} rd - 모서리 둥글기(px) [Optional, 기본값: 8]
 * @param {('full'|'bottom'|'left'|'right'|'top')} borderType - 테두리 형태 [Optional, 기본값: 'full']
 * @param {boolean} isMobile - 모바일 레이아웃 여부 [Optional]
 *
 * Example usage:
 * <CardPostBig thread={thread} date={thread.timestamp} isMobile={isMobile} />
 */
export const CardPostBig = ({ thread, date, rd = 8, borderType = 'full', isMobile }) => (
  <CardUnified
    variant="postBig"
    thread={thread}
    date={date}
    rd={rd}
    borderType={borderType}
    isMobile={isMobile}
  />
);
